import { CanDeactivate } from '@angular/router';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogRef } from '@angular/material/dialog';
import { Observable } from 'rxjs';

import { DialogConfirmComponent } from '../components/dialog-confirm/dialog-confirm.component';

export interface CanComponentDeactivate {
  canDeactivate: () => Observable<boolean> | Promise<boolean> | boolean;
}

@Injectable()
export class LeaveDirtyFormGuard implements CanDeactivate<CanComponentDeactivate> {
  constructor(
    public dialog: MatDialog,
  ) {}

  canDeactivate(component: CanComponentDeactivate) {
    const canDeactivate = (component.canDeactivate ? component.canDeactivate() : true);

    if (!canDeactivate) {
      return this.dialog.open(DialogConfirmComponent, {
        width: '400px',
        data: {
          text: 'shared.dialog.confirm.text.navigation'
        }
      }).afterClosed();
    } else {
      return true;
    }
  }
}
